<ng-container *ngIf="$savingPlan | async as savingPlan">
  <div class="track-deposit-widget" (click)="manage(savingPlan.status)">
    <div class="header">
      <div class="title">
        <ion-icon name="piggy"></ion-icon>
        <p class="ds-heading-3">
          <ng-container *ngIf="savingPlan.status !== 'not_set'">{{ savingPlan.percentage_funded | number: '1.0-0' }}% -</ng-container>
          {{ 'savingsPlanWidget.title' | translate: { year: year } }}
        </p>
      </div>
      <p class="ds-ui-3">{{ ('savingsPlanWidget.cta.' + savingPlan.status) | translate }}</p>
    </div>
    <app-ds-progress-bar [type]="types[savingPlan.status]" [percentage]="savingPlan.percentage_funded"></app-ds-progress-bar>
    <div class="status">
      <app-ds-badge [type]="types[savingPlan.status]">{{ ('savingsPlanWidget.badge.' + savingPlan.status) | translate }}</app-ds-badge>
      <div class="status-info">
        <p class="ds-ui-3">
          <ng-container *ngIf="savingPlan.status === 'not_set'; else set">{{ 'savingsPlanWidget.setUp' | translate }}</ng-container>
          <ng-template #set>
            {{ 'savingsPlanWidget.savingsStatus' | translate: { amount: savingPlan.amount_funded_this_year.toFixed(0) | thousand: currency,
            total: savingPlan.total_amount_for_current_year.toFixed(0) | thousand: currency } }}
          </ng-template>
        </p>
      </div>
      <div class="status-icon">
        <ion-icon name="info2" (click)="toggleInfo($event)"></ion-icon>
      </div>
    </div>
    <div *ngIf="showInfo" class="deposit-info">
      <p class="ds-ui-3">{{ ('savingsPlanWidget.hint.' + savingPlan.status) | translate }}</p>
    </div>
  </div>
</ng-container>
